import React, { useState } from 'react';
import { Box, Pagination } from '@mui/material';
import { CategoryData, JSONRecord } from './utils/jsonDataProcessing';

interface KeywordDataTableProps {
  parsedData: JSONRecord[];
  categoryData: CategoryData;
}

const KeywordDataTable: React.FC<KeywordDataTableProps> = ({ parsedData, categoryData }) => {
  const [page, setPage] = useState(1);
  const rowsPerPage = 10;

  // Helper to check if a record has a specific category
  const hasCategory = (record: JSONRecord, category: string): boolean => {
    // Check in topics
    if (record.classification.topics.some(t => t.name === category)) return true;
    // Check in subtopics
    if (record.classification.subtopics.some(s => s.name === category)) return true;
    return false;
  };

  return (
    <>
      <Box sx={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f8f8f8' }}>
                Query
              </th>
              {categoryData.categories.map((category, idx) => (
                <th key={idx} style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f8f8f8' }}>
                  {category}
                </th>
              ))}
              <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f8f8f8' }}>
                Location
              </th>
              <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f8f8f8' }}>
                Intent
              </th>
            </tr>
          </thead>
          <tbody>
            {parsedData
              .slice((page - 1) * rowsPerPage, page * rowsPerPage)
              .map((record, rowIdx) => (
                <tr key={record.id} style={{ backgroundColor: rowIdx % 2 === 0 ? 'white' : '#f9f9f9' }}>
                  <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                    <b>{record.query}</b>
                  </td>
                  {categoryData.categories.map((category, cellIdx) => (
                    <td key={cellIdx} style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>
                      {hasCategory(record, category) ? '✓' : ''}
                    </td>
                  ))}
                  <td style={{ border: '1px solid #ddd', padding: '8px', fontSize: '0.9em' }}>
                    {record.classification.location?.city_or_town || record.classification.location?.state_or_province || '-'}
                  </td>
                  <td style={{ border: '1px solid #ddd', padding: '8px', fontSize: '0.9em' }}>
                    {record.classification.metadata?.search_intent || '-'}
                  </td>
                </tr>
            ))}
          </tbody>
        </table>
      </Box>
      
      <Box display="flex" justifyContent="center" mt={3}>
        <Pagination 
          count={Math.ceil(parsedData.length / rowsPerPage)}
          page={page}
          onChange={(e, newPage) => setPage(newPage)}
          color="primary"
          showFirstButton
          showLastButton
        />
      </Box>
    </>
  );
};

export default KeywordDataTable;
